import { useQuery } from '@tanstack/react-query';

import { PricingPlanPeriodAdjustment } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/pricing-plan-period-adjustment/:adjustmentId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    planId: string;
    adjustmentId: string;
    parkingId: string;
}
const queryFn = ({ planId, adjustmentId, parkingId }: DTO): Promise<PricingPlanPeriodAdjustment> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, adjustmentId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPricingPlanAdjustment };
